import { SessionState } from "../session.slice.ts";
// import { PayloadAction } from '@reduxjs/toolkit';

export default function setClosedSessionReducer(
  state: SessionState,
  // action: PayloadAction<void>,
) {
  state.isWebsocketConnected = false;
  state.isClosedByServer = true;
}
